import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SECTIONS } from "./hubSections";

const AUBERGINE = "#3E1F46";
const PLUM = "#5B2A4F";

export default function AdminHubSection() {
  const { section } = useParams();
  const s = SECTIONS[section];
  if (!s) return <Navigate to="/admin" replace />;
  const Icon = s.Icon;

  return (
    <div data-testid={`hub-section-${section}`} className="max-w-5xl">
      <Link to="/admin" data-testid="hub-section-back" className="inline-flex items-center gap-1.5 text-[10px] tracking-[0.3em] uppercase font-semibold hover:underline" style={{ color: PLUM }}>
        <ArrowLeft className="w-3.5 h-3.5" /> Dashboard
      </Link>
      <header className="flex items-center gap-4 mt-3 mb-8">
        <div className="w-16 h-16 rounded-md flex items-center justify-center shrink-0" style={{ backgroundColor: s.tile }}>
          <Icon className="w-9 h-9" strokeWidth={1.3} style={{ color: AUBERGINE }} />
        </div>
        <div>
          <h1 className="font-serif text-4xl" style={{ color: AUBERGINE }}>{s.label}</h1>
          <p className="text-sm italic text-[#6E5849] mt-0.5">{s.blurb}</p>
        </div>
      </header>

      <section className="grid grid-cols-2 md:grid-cols-3 gap-4" data-testid="hub-section-tiles">
        {s.links.map((l) => {
          const LIcon = l.Icon;
          return (
            <Link
              key={l.to + l.label}
              to={l.to}
              data-testid={`section-tile-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="bg-white border border-[#E0D1C8] rounded-md p-5 hover:shadow-lg hover:-translate-y-0.5 transition-transform flex flex-col gap-3"
            >
              <div className="w-11 h-11 rounded-md flex items-center justify-center" style={{ backgroundColor: s.tile }}>
                <LIcon className="w-6 h-6" strokeWidth={1.4} style={{ color: AUBERGINE }} />
              </div>
              <div>
                <div className="font-serif text-lg leading-tight" style={{ color: AUBERGINE }}>{l.label}</div>
                <div className="text-xs text-[#7A6A55] mt-0.5">{l.blurb}</div>
              </div>
            </Link>
          );
        })}
      </section>
    </div>
  );
}
